import { render, staticRenderFns } from "./GiftCardItems.vue?vue&type=template&id=4dc8436f&scoped=true"
import script from "./GiftCardItems.vue?vue&type=script&lang=js"
export * from "./GiftCardItems.vue?vue&type=script&lang=js"
import style0 from "./GiftCardItems.vue?vue&type=style&index=0&id=4dc8436f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8436f",
  null
  
)

export default component.exports